
import { FrequencyType } from "@/models/base";
import { FrequencyDocumentEditState } from "@/utils/frequency-document-edit-state";
import { v4 } from "uuid";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			uid: v4()
		};
	},
	props: {
		state: {
			type: Object as ()=>FrequencyDocumentEditState,
			required: true
		}
	},
	computed: {
		weeklyValue():FrequencyType{
			return FrequencyType.Weekly;
		},
		monthlyValue():FrequencyType{
			return FrequencyType.Monthly;
		},
		monthlyPerWeekValue():FrequencyType{
			return FrequencyType.MonthlyPerWeek;
		},
		yearlyValue():FrequencyType{
			return FrequencyType.Yearly;
		}
	},
	methods: {
		isChecked(val:FrequencyType):boolean{
			return this.state.doc.FrequencyType == val;
		},
		setVal(val:FrequencyType){
			this.state.doc.FrequencyType = val;
			let date = new Date();
			let weekday = date.getDay();
			if (weekday < 0) {
				weekday = 6;
			}
			if (this.state.doc.FrequencyType == FrequencyType.Weekly) {
				this.state.doc.FrequencyMoment = `${weekday}`;
			} else if (this.state.doc.FrequencyType == FrequencyType.Monthly) {
				this.state.doc.FrequencyMoment = `${date.getDate()}`;
			} else if (this.state.doc.FrequencyType == FrequencyType.MonthlyPerWeek) {
				this.state.doc.FrequencyMoment = `1/${weekday}`;
			} else if (this.state.doc.FrequencyType == FrequencyType.Yearly) {
				this.state.doc.FrequencyMoment = `${date.getDate()}/${date.getMonth() + 1}`;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
